import { PHONE, PHONE_BUNDLE, PHONE_LINK } from 'utils/constants';

const es = {
  common: {
    days_amount_one: '{{count}} día',
    days_amount_other: '{{count}} días',
    months_amount_one: '{{count}} mes',
    months_amount_other: '{{count}} meses',
    minutes_amount_one: '{{count}} minuto',
    minutes_amount_other: '{{count}} minutos',
    minutes_one: 'minuto',
    minutes_other: 'minutos',
    hours_amount_one: '{{count}} hora',
    hours_amount_other: '{{count}} horas',
    hours_one: 'hora',
    hours_other: 'horas',
    seconds_one: 'segundo',
    seconds_other: 'segundos',
    days_one: 'día',
    days_other: 'días',
    months_one: 'mes',
    months_other: 'meses',
    back: 'Volver',
    currency: '€',
    continue: 'Continuar',
    understood: 'Entendido',
    email: 'info@vivus.es',
    email_2: 'recibos@vivus.es',
    phone: PHONE,
    phone_link: PHONE_LINK,
    welcome: 'Hola {{name}}',
    download: 'Descargar',
    consent_not_checked: 'Se requiere este consentimiento',
  },
  selektra_dashboard: {
    heading: 'DESCUBRE CUÁNTO PUEDES AHORRAR',
    body: 'Recibe asesoramiento <1>gratuito</1> para reducir tus facturas.',
    cta: 'AHORRAR YA',
    minimized_text: '¿PAGAS DE MÁS EN<br/>TUS FACTURAS?',
  },
  selektra_iframe: {
    iframe_title: 'Comparador de tarifas Selectra',
  },
  mobile_banner: {
    title: '¡Descarga la App de Vivus!',
    desc: 'Y empieza a gestionar tu préstamo con más comodidad',
    points: {
      point_1: 'Desde donde tú quieras',
      point_2: 'Fácil, rápido y seguro',
      point_3: 'Acceso por reconocimiento facial o huella dactilar',
    },
    scan: 'Escanea este código QR con tu teléfono para descargar la aplicación.',
    download: 'Descargar la aplicación hoy',
    submit_cto: {
      agreed: 'entendido',
      client: 'ir al área de cliente',
      continue: 'continuar',
    },
  },
  error: {
    generic: 'Algo salió mal. Inténtalo de nuevo más tarde.',
    routerBanner:
      'Esta ruta es insegura. Un desarrollador debe añadir esta pantalla a la función "checkBEConditions" del componente "GuardRoute"',
    invalidLoan:
      'Ha habido un problema para obtener información sobre su préstamo. Por favor, inténtalo de nuevo',
    session_expired: 'Tu sesión ha finalizado debido a inactividad',
    register: 'Hubo un problema con el registro. Por favor, inténtalo de nuevo',
    duplicatePayment:
      'Petición de pago duplicada. Por favor, espera un momento para repetirlo',
    address: 'Error al actualizar la dirección. Inténtalo de nuevo más tarde.',
    validation: {
      400: 'Petición malformada, intentalo de nuevo',
      401: 'Se requiere autorización',
      403: 'No tienes permisos para realizar esa operación',
      404: 'Datos no encontrados',
      405: 'Método no permitido',
      407: 'Se requiere autenticación de proxy',
      408: 'El servidor se agotó esperando el resto de la petición del navegador',
      418: 'Soy una tetera',
      500: 'Error del servidor',
      already_exists_in_db: 'Si ya eres cliente entra en tu área de cliente.',
      already_exists_in_db_phone: 'Teléfono ya en uso.',
      already_exists_in_db_phone_modal:
        'No es posible realizar el cambio con este número de teléfono',
      document_file_type_size:
        'El formato del archivo no es válido. Formatos aceptados: JPG, PNG, BMP, GIF, TIFF, HEIC, HEIF o PDF y tamaño máximo del fichero: 25 MB',
      empty_email_or_dni: 'Email o DNI/NIE es obligatorio.',
      empty_password: 'Este campo es obligatorio.',
      generic_2fa_error:
        'Algo salió mal durante la doble verificación. Inténtalo de nuevo más tarde.',
      incorrect_password: 'Contraseña incorrecta.',
      incorrect_code: 'Código incorrecto',
      session: `Ha surgido un problema.<br />Por favor, ponte en contacto con nosotros en el teléfono <span><a href="tel:{{phoneLink}}">{{phone}}</a>.</span>`,
      soldDebt: {
        entities: `Recuerda que tu préstamo fue cedido a la entidad {{entity}}.`,
        prePhones: ` Para cualquier información deberás contactar en los siguientes teléfonos`,
        phoneEmailSeparator: '<br />o',
        preEmailsWithoutPhones:
          ' Para cualquier información deberás contactar en las siguientes <br />direcciones de correo electrónico',
        preEmailsWithPhones: '<br />o direcciones de correo electrónico',
      },
      login_unavailable: `Ha surgido un problema.<br />Por favor, ponte en contacto con nosotros en el teléfono <a href="tel:${{
        PHONE_LINK,
      }}">${{
        PHONE,
      }}</a>.`,
      not_email: 'Email formato incorrecto.',
      not_email_nor_dni: 'Email o DNI/NIE Formato incorrecto.',
      password_contains_space: 'El carácter de espacio no está permitido',
      password_is_same_as_old:
        'La nueva contraseña debe ser diferente a la antigua.',
      new_passwords_is_different: 'Las contraseñas no coinciden',
      //TODO: hotfix/cwt-2823 take back when ready
      unauthorized:
        'Email, DNI/NIE o contraseña incorrectos. \nPor favor, comprueba tus datos e inténtalo de nuevo.',
      verification_id_not_created:
        'Ha habido un problema con el identificador del dispositivo.',
      email_not_found_by_client_number:
        'Email no encontrado, por favor, comprueba tus datos e inténtalo de nuevo',
      client_not_found_by_client_number:
        'No se ha encontrado el identificador del cliente.',
      client_number_not_found_by_verification_id:
        'No se ha encontrado un cliente relacionado con el identificador del dispositivo',
      verification_id_not_found_by_code_id:
        'No se ha encontrado un código relacionado con el identificador del dispositivo',
      code_not_matched: 'Código incorrecto',
      notification_sender_not_found:
        'No se encontró ningún remitente de notificación',
      client_number_not_found_by_code_id:
        'Número de cliente no encontrado con el código proporcionado',
      weak_password:
        'Se requiere un mínimo de 8 carácteres, un número o carácter especial (!@#%&*), una minúscula y una mayúscula.',
      not_valid:
        'Por favor, vuelve a intentarlo usando otro correo electrónico.',
      not_valid_phone:
        'No es posible realizar el cambio con este número de teléfono',
      too_many_attempts:
        'Se han realizado demasiados intentos. Por favor, espere unos minutos antes de intentarlo de nuevo.',
      rate_limit_exceeded:
        'Se han realizado demasiados intentos. Por favor, espere unos minutos antes de intentarlo de nuevo.',
      required_field: 'Campo obligatorio.',
      wrong_format: 'Formato incorrecto.',
      wrong_phone: 'Teléfono incorrecto',
      too_short: 'Muy corto.',
      too_long: 'Muy largo.',
      wrong_number_address_format:
        'Formato incorrecto. Se permite: número, sn o número+espacio+"bis"',
      required_direction_number:
        'Campo obligatorio. Si tu dirección postal no tiene número, introduce s/n',
      wrong_floor_address_format:
        'Formato incorrecto. Se permite: número o "bajo"',
      wrong_door_address_format:
        'Formato incorrecto. Se permite: número o numero+letra',
    },
    user_not_identified: 'Envíanos tu documentación para continuar',
  },

  footer: {
    work_hours_weekdays:
      'Lunes – Viernes / 8:00 – 21:00, Sábado / 9:00 – 20:00',
    work_hours_weekends: 'Festivos nacionales / 9:00 – 14:00',
    payFullLoan: 'Pagar todo el préstamo',
    terms_and_conditions:
      '<a target="_blank" rel="noopener" href="https://www.vivus.es/condiciones/generales">Términos y condiciones</a>',
  },

  footerOverdue: {
    title: '¿Necesitas ayuda?',
    email: 'recibos@vivus.es',
    work_hours_weekdays: 'Lunes a Viernes de 8:00 a 18:00 horas',
    work_hours_weekends: 'Sábados de 9:00 a 13:00 horas',
    pay_full_loan: 'Pagar todo el préstamo',
  },

  document_upload: {
    additionalDocument: 'Documento adicional',
    id_front_title: 'Parte delantera de tu DNI / NIE',
    id_back_title: 'Parte trasera de tu DNI / NIE',
  },

  menu: {
    dashboard: 'Mi área personal',
    additional_amount: 'Ampliar mi préstamo',
    extention: 'Aplazar el pago',
    repayment: 'Realizar el pago',
    help: '¿Te ayudamos?',
    profile: 'Mis datos',
    logout: 'Cerrar sesión',
    vivus_plus: 'Vivus Plus',
    learn_vivus_plus: 'Aprende con Vivus',
  },

  menuButton: {
    popular: 'más popular',
  },

  documentTypes: {
    frontSideDni: 'DNI (parte frontal)',
    backSideDni: 'DNI (parte trasera)',
    bankReceipt: 'Recibo bancario',
    idCard: 'Tarjeta de identificación',
    passport: 'Pasaporte',
    gunLicense: 'Licencia de armas',
    driversLicense: 'Licencia de conducir',
    photo: 'Foto',
    otherDocument: 'Otro documento',
    incomeDocument: 'Documento de ingreso',
  },

  bankAccountModal: {
    header_bank_account: 'Cambiar cuenta bancaria',
    content_header_bank_account: 'Cambiar cuenta bancaria',
    content_address: `Para cambiar tu dirección contacta con nuestro servicio de atención al cliente en el <a href="tel:{{phoneLink}}">{{phone}}</a>.`,
    content_bank_account_open_loan:
      'No se puede modificar la cuenta bancaria con un préstamo abierto',
    content_bank_account_TINK:
      'Para modificar tu cuenta bancaria utilizamos los servicios de TINK AB que se conecta a tu banca on-line para extraer de forma segura tus datos identificativos e IBAN. <a href="https://www.vivus.es/faq/como-puedo-cambiar-mi-cuenta-bancaria" target="_blank">Más información</a>.<br /><a href="https://www.vivus.es/condiciones/politica-de-privacidad" target="_blank">Política de Privacidad</a>',
    content_bank_account_UNNAX:
      'Para modificar tu cuenta bancaria utilizamos los servicios Unnax Regulatory Services, EDE, SL<br/><a href="https://www.vivus.es/faq/como-puedo-cambiar-mi-cuenta-bancaria" target="_blank">Más información</a>',
    consents_bank_account: 'Quiero cambiar mi número de cuenta',
    content_tink_result_success: 'Cuenta bancaria cambiada con éxito.',
    content_tink_result_success_same_iban:
      'No ha sido posible el cambio. Has seleccionado la cuenta que ya tienes actualmente registrada.',
    content_tink_result_error:
      'No ha sido posible realizar el cambio. Será necesario que selecciones otro banco u otra cuenta bancaria.',
    confirm_btn: 'Entendido',
    continue_btn: 'continuar',
  },

  dashboard: {
    overdueBanner: 'Tu préstamo venció hace',
    overdue7Banner: 'Tu cuota venció hace',
    profile: {
      html_title: 'Área personal - Vivus.es',
      welcome: 'Hola ',
      info_title_1: 'Tus datos personales',
      name: 'Nombre',
      date_of_birth: 'Fecha de nacimiento',
      bank_account: 'Cuenta bancaria',
      address: 'Dirección',
      password: 'Contraseña',
      password_placeholder: '● ● ● ● ● ● ●',
      email: 'E-mail',
      phone: 'Teléfono',
      info_title_2: 'Preferencias de comunicación',
      accept_news: `Consiento recibir publicidad personalizada de VIVUS FINANCIAL SERVICES, S.A., las empresas del Grupo VIVUS y terceros colaboradores, sobre descuentos, promociones, ofertas y novedades (<a href="https://www.vivus.es/condiciones/marketing-y-comunicacion" target="_blank" rel="noopener">más información</a>).`,
      via_email: 'Por via E-mail',
      via_sms: 'Por SMS',
      via_phone: 'Por Teléfono',
      accept_data_sharing: `Consiento que VIVUS FINANCIAL SERVICES, S.A. comunique mis datos a sus partners para que me informen, en base a mi perfil, sobre sus productos o servicios (<a href="https://www.vivus.es/condiciones/comunicaciones-a-terceros" target="_blank" rel="noopener">más información</a>).`,
      card_title: 'Tarjeta bancaria',
      add_card:
        '+ Añade tu tarjeta de crédito o débito para activar el pago automático de tu crédito.',
      add_card_more_info: 'Más información',
      add_auto_repayment: 'Activa el pago de tu crédito de manera automática.',
      auto_repayment_link: 'Más información',
      active_auto_repayment_1: 'Pago automático activado.',
      active_auto_repayment_2: 'El próximo pago será el {{date}}.',
      modal_auto_repayment: {
        header: 'Pago automático',
        title: '¿Quieres desactivar el pago automático?',
        description:
          'AVISO: Al desactivar este servicio tendrás la responsabilidad de realizar los pagos en las fechas correctas aumentando tu riesgo de impago',
        no: 'No',
        yes: 'Sí',
      },
      modal: {
        header_name: 'Cambiar nombre',
        header_address_disabled: 'Cambiar dirección',
        header_date_of_birth: 'Cambiar fecha de nacimiento',
        header_email: 'Cambiar e-mail',
        header_phone: 'Cambiar teléfono',
        header_password: 'Modificar contraseña',
        content_header_name: 'Cómo cambiar tu nombre',
        content_header_date_of_birth: 'Cómo cambiar tu fecha de nacimiento',
        content_header_email: 'Cómo cambiar tu e-mail',
        content_header_password: 'Introducir contraseña',
        content_name: `Para cambiar tu nombre contacta con nuestro servicio de atención al cliente en el <a href="tel:{{phoneLink}}">{{phone}}</a>.`,
        content_date_of_birth: `Para cambiar tu fecha de nacimiento contacta con nuestro servicio de atención al cliente en el <a href="tel:{{phoneLink}}">{{phone}}</a>.`,
        content_email: `Para cambiar tu e-mail contacta con nuestro servicio de atención al cliente en el <a href="tel:{{phoneLink}}">{{phone}}</a>.`,
        old_password_placeholder: 'Contraseña antigua',
        new_password_placeholder: 'Nueva contraseña',
        confirm_btn: 'Entendido',
        button_change_password: 'Guardar contraseña',
      },
      modal_address: {
        title: 'Tu dirección',
        street: 'Nombre de la Calle, Avenida, Plaza...',
        number: 'Número',
        flat: 'Piso',
        door: 'Puerta/Letra',
        gate: 'Bloque, Portal, Escalera...',
        postalCode: 'Código Postal',
        province: 'Provincia',
        city: 'Ciudad',
        cto: 'Actualizar dirección',
      },
      modal_addressConfirm: {
        title: 'Confirma la modificación de tu dirección',
        desc: 'Tu nueva dirección será:',
        cto: 'continuar',
        link: 'Prefiero mantener mi antigua dirección',
      },
    },
  },
  repayment_extension_payment: {
    bizum_info:
      'Gestiona tu pago con más rapidez utilizando tu número de teléfono',
  },
  repayment: {
    heading: 'Pagar deuda',
    heading_broken_loan: 'Hacer pago',
    html_title: 'Realizar el pago - Vivus.es',
    title: 'Importe a pagar',
    card_heading: 'Pagar con tarjeta bancaria',
    card_info: 'Esta es la opción más cómoda y rápida.',
    manual_transfer_heading: 'Transferencia bancaria',
    manual_transfer_info: 'De 24 a 48 horas hábiles para procesar el pago.',
    postpone_heading: '¿Necesitas más tiempo?',
    partial_payment: 'Pago parcial',
    postpone_info:
      'Puedes aplazar la fecha de vencimiento de tu pago por un coste adicional.',
    postpone_info_mini8:
      'Puedes aplazar la fecha de vencimiento de tu pago por un coste adicional.',
    postpone_info_6:
      'Puedes aplazar la fecha de vencimiento de tu pago por un coste adicional.',
    early_repayment_total: 'Total a devolver hoy',
    early_repayment_principal: 'Importe',
    early_repayment_fee: 'Comisión de cancelación anticipada',
    early_repayment_text:
      'Vas a cancelar tu préstamo anticipadamente. <br />La comisión por cancelación anticipada es de <b>0,5%</b> del principal pendiente.',
    penalties_penalty_one:
      'El importe incluye {{value}} en concepto de penalizaciones al realizarse el pago con {{count}} día de retraso.',
    penalties_penalty_other:
      'El importe incluye {{value}} en concepto de penalizaciones al realizarse el pago con {{count}} días de retraso.',
    penalties_commission_one:
      'El importe incluye {{value}} en concepto de gastos asociados a realizar el pago con {{count}} día de retraso.',
    penalties_commission_other:
      'El importe incluye {{value}} en concepto de gastos asociados a realizar el pago con {{count}} días de retraso.',
    penalties_penalty_and_commission_one:
      'El importe incluye {{value}} en concepto de penalizaciones y gastos asociados a realizar el pago con {{count}} día de retraso.',
    penalties_penalty_and_commission_other:
      'El importe incluye {{value}} en concepto de penalizaciones y gastos asociados a realizar el pago con {{count}} días de retraso.',
    heading_full_repayment: 'Realizar pago',
    pay_now: 'Deuda pendiente',
    pay_now_overdue: 'Total deuda pendiente',
    pay_now_partial: 'Pago parcial',
    open_amount: 'Importe',
    monthly_payments: 'Mensualidad',
    payment_notification:
      'Podrás realizar el pago de tu mensualidad en tu fecha de pago: <b>{{date}}</b>.',
    bizum_heading_overview: 'Pagar con Bizum',
    bizum_heading_brokenloan: 'Pagar con Bizum',
    bizum_heading: 'Bizum',
    bizum_heading_DR: 'Pagar con Bizum',
    summary_card: {
      title: 'Resumen del pago',
      price: 'Importe',
      contract: 'Contrato nº',
    },
    checkbox_overdue_card:
      'Activa el pago automático para futuros préstamos. Nosotros nos encargaremos de cobrar tu préstamo en la fecha correcta',
    checkbox_overdue_card_full_repayment_7_CONS:
      'Activa el pago automático para futuros préstamos. Nosotros nos encargaremos de cobrar tu préstamo en la fecha correcta.',
    checkbox_overdue_card_7_CONS:
      'Activa el pago automático para el cobro de tus próximas cuotas y préstamos. Nos encargaremos de hacer el cargo en la fecha de vencimiento. ',
    checkbox_dr:
      'Activa el pago automático y nos encargaremos de cobrar tus cuotas mensuales en las fechas acordadas.',
    check_box_overdue:
      'Activa el pago  automático y nos encargaremos de cobrar los {{amount}} € de tu préstamo en la nueva fecha de vencimiento {{date}}',
    check_box: 'Activa el pago automático de tus préstamos.',
    check_box_more_information: 'Más información',
    pay_button: 'PAGAR PRÉSTAMO',
    pay_button_7_cons: 'PAGAR CUOTA',
    pay_partial_button: 'HACER PAGO',
  },

  two_factor_auth: {
    html_title: '2FA - Vivus.es',
    heading: 'Verifica tu teléfono',
    text: 'Introduce el código SMS que te hemos enviado al {{phone}}',
    spam: {
      text: 'Recuerda revisar tu carpeta de SPAM',
      link: 'Más información',
    },
    resend: 'Si necesitas recibir otro código',
    resend_disabled: ' debes esperar',
    resend_enabled: ', haz click',
    change_phone: 'Si tu teléfono no es {{phone}}, haz click',
    here_link: 'aquí',
    cant_continue:
      'Si no puedes continuar con el proceso pulsa <a target="_blank" href="https://www.vivus.es/faq/como-puedo-cambiar-mis-datos">aquí</a>',
    cant_continue_tooltip:
      'Escríbenos un email a <a href="mailto:info@vivus.es">info@vivus.es</a> indicándonos el nuevo número de teléfono móvil que quieres registrar y adjuntando fotografía de tu DNI/NIE por ambas caras.',
  },

  two_factor_auth_change_phone: {
    html_title: '2FA change phone - Vivus.es',
    heading: 'Indica tu nuevo número de teléfono',
    text: 'Para modificar tu teléfono de forma segura necesitamos verificar tu identidad. Para ello utilizamos la herramienta TINK que se conecta con tu banca online y nos permite confirmar tu identidad. <a target="_blank" href="https://www.vivus.es/faq/como-puedo-cambiar-mi-numero-de-telefono-o-de-movil">Más información</a> . <a target="_blank" href="https://www.vivus.es/condiciones/politica-de-privacidad">Política de privacidad</a>.',
    checkbox: 'Quiero cambiar mi número de teléfono',
    error_already_in_use:
      'No es posible realizar el cambio con este número de teléfono',
  },

  login: {
    html_title: 'Inicio de sesión - Vivus.es',
    header: '¡Bienvenido!',
    email: 'Email o DNI/NIE',
    password: 'Contraseña',
    submit: 'Accede a tu área personal',
    forgot_password: 'Generar nueva contraseña',
    menu_blog: 'Blog',
    menu_help: '¿Te ayudamos?',
    menu_how_works: 'Cómo funciona',
    menu_offer: 'Oferta',
    help_title: '¿Necesitas ayuda?',
    ready_to_answer: '¡Resolvemos todas tus dudas!',
    help_text1: 'Consulta las',
    help_text2: 'preguntas más frecuentes',
    finance_group: `© VIVUS SPAIN FINANCIAL SERVICES, S.A.U, sociedad de nacionalidad española, perteneciente a VIVUS Group`,
    working_hours: 'Horario de atención:',
    work_normal: 'Lunes – Viernes / 8:00 – 21:00',
    work_holidays: 'Festivos nacionales / 9:00 – 14:00',
    support_email: 'info@vivus.es',
    support_online_email: 'info@vivusonline.es',
    work_saturday: 'Sábado / 9:00 – 20:00',
    affiliates:
      'Tu préstamo ha sido pre-aprobado. Entra en tu cuenta Vivus y finaliza la solicitud.',
    edit: 'Modificar',
    change_email_title: 'Correo electrónico',
    change_email_description:
      'Si quieres modificar tu correo electrónico contacta con nosotros:',
    change_email_close: 'Cerrar',
  },

  extensions: {
    html_title: 'Aplazar el pago — Vivus.es',
    mobile_title: 'Aplaza el pago',
    title: 'Hola {{name}},<br />te ayudamos a aplazar',
    desc: 'Elige cuantos días quieres aplazar tu préstamo',
    desc_overdue: 'Elige cuántos días quieres aplazar tu deuda',
    subtitle_default: 'Recomendado para ti',
    subtitle_selected: 'extensión seleccionada',
    dropdown_title: 'Ver otras opciones',
    term_subtitle: 'Aplaza hasta el {{date}}',
    option_date: 'Hasta el',
    flexibility: 'Máxima flexibilidad',
    balanced: 'Plan equilibrado',
    tab_flexible: 'flexible',
    tab_balanced: 'equilibrado',
    days_unit: 'días',
    button: 'aplazar {{term}} días · {{amount}}',
    // notification
    overdueTo25_8:
      'Te condonamos {{penalties}} € de penalizaciones y paga <span>{{fee}} €</span> en una nueva fecha',
    overdueFrom26_8:
      'Te condonamos {{penalties}} € de penalizaciones y paga <span>{{fee}} €</span> en una nueva fecha',
    overdueWarning:
      'Evita <strong>{{penalties}}</strong> € de penalizaciones y paga <span>{{fee}} €</span> en una nueva fecha.',
  },

  extension_payment: {
    html_title: 'Aplazar el pago de préstamo — Vivus.es',
    mobile_header: 'Realizar pago',
    subtitle:
      'Una vez contratado el aplazamiento de {{term}} tu nueva fecha de pago será el {{date}}.',
    card_info: 'Esta es la opción más cómoda y rápida.',
    heading: 'Elige un método de pago',
    card_heading: 'Pagar con tarjeta bancaria',
    bank_heading: 'Transferencia bancaria',
    bank_info: 'De 24 a 48 horas hábiles para procesar el pago.',
    bizum_heading: 'Pagar con Bizum',
    payNowCard: {
      title: 'Paga ahora',
      description: 'y devuelve tu préstamo el',
    },
    pauseDebt: {
      title: '¿No puedes pagar hoy?',
      description:
        'Elimina las penalizaciones generadas y pausa tu deuda pagando una pequeña cantidad.',
    },
  },

  extension_success: {
    html_title: 'Aplazar el pago de préstamo — Vivus.es',
    mobile_heading: 'Pago en proceso',
    heading: 'Pago en proceso',
    titleDescription: 'Una vez procesado el pago:',
    description:
      '<ul><li>Recibirás confirmación vía SMS (en unos minutos) con tu nueva fecha de pago</li><li>Actualizaremos la información de tu préstamo en tu área de cliente</li><li>Si has seleccionado el cargo automático, en la nueva fecha de vencimiento cargarmeos el pago de tu préstamo.</li></ul>',
  },
  card_payments: {
    html_title:
      'Ten lista tu tarjeta, necesitaremos que introduzcas la numeración - Vivus.es',
    title: 'Ten lista tu tarjeta, necesitaremos que introduzcas la numeración',
    mobile_heading: 'PAGO DEL PRÉSTAMO',
    check_box: 'Activa el pago automático de tus préstamos.',
    check_box_more_information: 'Más información',
    pay_button: 'Pagar {{amount}}',
    active_card: {
      title: 'Pago con tarjeta de débito o crédito',
      card_title: 'Tu tarjeta',
    },
    success: {
      mini: {
        html_title: 'Pago en proceso – Vivus.es',
        title: 'Pago en proceso',
        mobile_heading: 'Pago en proceso',
        info_title: 'Una vez procesado el pago:',
        info: '<ul><li>Recibirás confirmación vía SMS (en unos minutos) con tu nueva fecha de pago.</li><li>Actualizaremos la información de tu préstamo en tu área de cliente.</li><li>Si has seleccionado el cargo automático, en la nueva fecha de vencimiento cargaremos el pago de tu préstamo.</li></ul>',
      },
      cons: {
        html_title: 'Pago en proceso – Vivus.es',
        title: 'Pago en proceso',
        mobile_heading: 'Pago en proceso',
        titleInfo: 'Una vez procesado el pago de tu cuota:',
        info: '<ul><li>Recibirás confirmación vía SMS (en unos minutos)</li><li>Actualizaremos la información de tu préstamo en tu área de cliente</li><li>Si has seleccionado el cargo automático, en la nueva fecha de vencimiento cargarmeos el pago de tu préstamo.</li></ul>',
      },
    },
  },

  repayment_wire_transfer: {
    html_title: 'Pago de préstamo — Vivus.es',
    mobile_heading: 'Realizar pago',
    heading_mini: 'Transferencia bancaria',
    heading_cons_and_extension: 'Transferencia bancaria',
    choose_bank: 'Elige el banco',
    choose_bank_description: 'Banco al que haces la transferencia',
    select_bank: 'Seleccionar banco',
    bank_details: 'Realiza el pago a través de tu banca online',
    bank_details_description:
      '1. Accede a tu banca online <br /><br /> 2. Realiza una transferencia utilizando los siguientes datos',
    bank_details_info_repayment:
      'El importe de la cantidad total a pagar incluye una comisión de cancelación anticipada del 0,5% del principal. Las transferencias entre bancos pueden tardar hasta 48h. Te confirmaremos la recepción de tu pago por E-mail y SMS.',
    bank_details_info_extension:
      'Las transferencias entre bancos pueden tardar hasta 48h. Te confirmaremos la recepción de tu pago por E-mail y SMS',
    complete: 'Hecho',
    copy_label: 'Copiar',
    bank_account_label: 'Cuenta bancaria',
    contract_number_label: 'Número del contrato',
    contract_number_notification: 'Anótalo en el concepto de tu transferencia',
    payment_amount: 'Cantidad total a pagar',
    other_bank: 'Otro banco',
  },

  calculator: {
    amount_heading: '¿Cuánto dinero necesitas?',
    term_heading: '¿En cuántos días quieres devolverlo?',
    instalment_heading: '¿En cuántos meses quieres devolverlo?',
    term_unit: 'días',
    mini: 'En un pago',
    cons: 'A plazos',
  },

  instalment_card: {
    available_from: 'Disponible desde {{amountFrom}}',
    available_to: 'Disponible hasta {{amountTo}}',
    payment: 'Pago mensual',
    intrest: 'Intereses',
    total_to_return: 'Total a devolver',
  },

  repeated_loan: {
    html_title: 'Mi área personal - Vivus.es',
    heading: 'Elige importe y plazo',
    payment_schedule: 'Plan de pago',
    requested_amount: 'Importe solicitado',
    interest: 'Intereses',
    total_to_return: 'Total a devolver',
    term: 'Plazo',
    last_payment_date: 'Fecha del último pago',
    repayment_date: 'Fecha del pago',
    apply: 'Solicitar mi préstamo',
    missing_personal_id_notification_text:
      'Facilítanos una fotografía de tu DNI / NIE por ambas caras para finalizar tu solicitud y transferirte los {{amount}} €.',
    missing_personal_id_button: 'Sube tu documentación',
    legal_terms: 'Información sobre el préstamo',
    cons_banner: '¡Pide tu préstamo desde 400€ y págalo a plazos!',
  },

  check_documents: {
    additionalDocuments:
      '+ Documentos adicionales si eres ciudadano/a de la UE (DNI o pasaporte de tu país)',
    html_title: 'Sube tu DNI / NIE - Vivus.es',
    header: 'Sube tu DNI o NIE para seguir disfrutando Vivus',
    subheader:
      'En cumplimiento con el Real Decreto de 2014/14, necesitamos verificar tu identidad. Puede tardar hasta 1h.',
    confirm_button: 'ENVIAR PARA APROBACIÓN',
    modalInfoDoc: {
      text: 'Asegúrate de que las fotos de tu DNI/NIE sean legibles, nítidas y muestren el documento completo sobre un fondo de color neutro.',
      button: 'CONTINUAR',
    },
    modalNewDocument: {
      title: '¿Qué tipo de documento desea subir?',
      selectPlaceholder: 'Seleccione tipo de documento.',
      submitBtn: 'CONTINUAR',
      titleSecondStep: 'Subir {{documentType}}',
      selectFile: 'SELECCIONAR ARCHIVO',
    },
  },

  loan_check_details: {
    html_title: 'Comprobando tu información – Vivus.es',
    mobile_page_title: 'Comprobando tu información',
    title: 'Comprobando tu información',
    text: 'Por favor mantente a la espera y no cierres esta ventana. Este proceso puede tardar hasta 5 minutos.',
  },

  loan_check_details_insurance: {
    html_title: 'Comprobando tu información – Vivus.es',
    mobile_page_title: 'Todo incluido',
    badge: 'Decisión exprés',
    title: 'Comprobando tu información',
    text: 'Mantente a la espera y no cierres esta ventana. Esto puede tardar unos segundos.',
    loading_text: 'Estamos revisando tu solicitud',
  },

  additional_amount: {
    html_title: 'Importe adicional – Vivus.es',
    badge_bundle: 'Número de importes adicionales ilimitados',
    heading: 'Puedes solicitar hasta {{maxAmount}} € adicionales',
    amount_heading: '¿Necesitas más dinero?',
    info: 'Ten en cuenta que estás incrementando el importe de tu crédito pero manteniendo la fecha de devolución',
    apply: 'CONTINUAR',
    additional_amount: 'Importe Adicional',
    interest: 'Intereses',
    total_to_return: 'A devolver',
    repayment_date: 'Fecha de devolución',
    warning:
      'Puedes solicitar un importe adicional hasta <strong>7 días</strong> antes de la fecha de pago de tu préstamo <strong>({{date}})</strong>. El dinero se enviará en un plazo de 7 días.',
  },
  loan_approved: {
    mobile_heading_main_loan: 'NUEVO PRÉSTAMO',
    mobile_heading_additional_amount: 'SOLICITA MÁS DINERO',
    html_title_main_loan: 'Préstamo concedido – Vivus.es',
    html_title_additional_amount:
      '¡Enhorabuena! Se ha aprobado la ampliación del importe de tu préstamo – Vivus.es',
    heading_additional_amount:
      '¡Enhorabuena! Se ha aprobado la ampliación del importe de tu préstamo',
    heading_main_loan: '¡Enhorabuena! ¡Tu préstamo ha sido concedido!',
    btn: 'Entendido',
    inner_card: {
      heading: 'Tiempo aproximado para recibir el dinero en tu cuenta',
      description:
        'Por favor, revisa el SMS y el E-mail que te hemos enviado donde podrás encontrar la documentación relativa a tu crédito.',
      bank_title: 'El dinero será transferido a esta cuenta:',
      a: 'a',
      hours: '48',
      h: 'h.',
      de: 'De',
      min: 'min.',
      time_min: '15',
    },
  },
  loan_approved_v2: {
    html_title: 'Préstamo concedido – Vivus.es',
    title: '¡Préstamo aprobado!',
    desc: 'Tu préstamo de {{amount}}€ estará en la cuenta terminada en <bankaccount>{{bankAccount}}</bankaccount> en menos de <b>15 minutos</b>',
    saveCard: {
      titleCard:
        'Para finalizar, registra tu tarjeta bancaria y activa el pago automático.',
      titleAutorepay: 'Para finalizar, activa el pago automático.',
      btn: 'continuar',
      footer:
        '¡Di adios a los intereses de demora y disfruta de ventajas increíbles!',
    },
    autorepay: {
      title: 'Para finalizar, activa el pago automático.',
      btn: 'activar',
      footer:
        '¡Di adios a los intereses de demora y disfruta de ventajas increíbles!',
    },
    submitBtn: 'ir al área de cliente',
    link: 'No, gracias',
    understoodBtn: 'Entendido',

    modal: {
      save_success: {
        title: 'Tarjeta añadida, y pago automático activado con éxito',
        btn: 'ir al área de cliente',
      },
      save_failed: {
        title: 'Lo sentimos, no hemos podido añadir tu tarjeta',
        btn: 'intentar de nuevo',
        link: 'No, gracias',
      },
      save_failed_final: {
        title: 'Lo sentimos, no hemos podido añadir tu tarjeta',
        btn: 'ir al área de cliente',
      },
      autorepay_success: {
        title: 'Pago automático activado con éxito',
        btn: 'ir al área de cliente',
      },
    },
    mobile_modal_btn: 'ir al área de cliente',

    preid: {
      title: '¡Gracias por confiar en nosotros!',
      subtitle:
        'Para poder gestionar futuras solicitudes es necesario que adjuntes tu DNI/NIE en vigor',
      btn: '¡ADJUNTAR AHORA!',
    },
  },

  rejected_or_failure: {
    failure_by_card: {
      html_title: 'Lo sentimos, реrо el pago por tarjeta ha fallado - Vivus.es',
      title: '¿Tienes otra tarjeta?',
      mobile_heading: 'Pago no realizado',
      description:
        'Desafortunadamente, la tarjeta introducida no es válida para realizar este pago. Por favor, inténtalo con otra tarjeta u otro método de pago.',
      button: 'Elegir otro método de pago',
    },
    loan_rejected_main: {
      mobile_heading: 'NUEVO PRÉSTAMO',
      html_title: 'Préstamo rechazado – Vivus.es',
      description:
        'Las causas más frecuentes por las que no somos capaces de ofrecerte un préstamo son: Haber tenido algún impago con nosotros en el pasado; Estar incluido en ficheros de morosidad; Tener algún otro crédito abierto en estos momentos. <br /><br /> <strong>Seguimos en contacto</strong> <br /> Nos gustaría poder ofrecerte un crédito en el futuro, por lo que no dejes de contactar de nuevo con nosotros pasado un tiempo.',

      title: 'Lo sentimos, en este momento no podemos ofrecerte un préstamo',
      button: 'entendido',
    },
    loan_rejected_additional: {
      mobile_heading: 'SOLICITA MÁS DINERO',
      html_title:
        'Lo sentimos, no puedes solicitar una cantidad adicional - Vivus.es',
      description: 'Has alcanzado tu límite de crédito',

      title: 'Lo sentimos, no puedes solicitar una cantidad adicional',
      desc: 'Las causas más frecuentes por las que no somos capaces de ofrecerte un préstamo son: Haber tenido algún impago con nosotros en el pasado; Estar incluido en ficheros de morosidad; Tener algún otro crédito abierto en estos momentos. <br /><br /> <strong>Seguimos en contacto</strong> <br /> Nos gustaría poder ofrecerte un crédito en el futuro, por lo que no dejes de contactar de nuevo con nosotros pasado un tiempo.',
      button: 'entendido',
    },
    loan_failed_main: {
      mobile_heading: 'NUEVO PRÉSTAMO',
      html_title: 'Préstamo fallido – Vivus.es',
      title: 'No ha sido posible cursar la solicitud para ampliar tu crédito',
      description: 'Por favor, inténtalo de nuevo en unos minutos',
      button: 'Entendido',
    },
    loan_failed_additional: {
      mobile_heading: 'SOLICITA MÁS DINERO',
      html_title: 'Préstamo fallido – Vivus.es',
      title: 'No ha sido posible cursar la solicitud para ampliar tu crédito',
      description: 'Por favor, inténtalo de nuevo en unos minutos',
      button: 'Entendido',
    },
    extension_rejected: {
      mobile_heading: 'Aplazar el pago de préstamo',
      html_title: 'Aplazar el pago de préstamo — Vivus.es',
      title: 'Tu pago no se ha realizado',
      description: `Puedes intentar de nuevo o elegir otro método de pago. Si tienes preguntas llámanos al <strong>{{phone}}</strong>.`,
      button: 'Intentar de nuevo',
      link: 'Elegir otro método de pago',
    },
    card_failure: {
      mobile_heading: 'Pago no realizado',
      html_title: 'Lo sentimos, реrо el pago por tarjeta ha fallado - Vivus.es',
      title: 'Tu pago no se ha realizado',
      description: `Puedes intentar de nuevo o elegir otro método de pago. Si tienes preguntas llámanos al <a href="tel:{{phoneLink}}">{{phone}}</a>`,
      button: 'Intentar de nuevo',
      link: 'Elige otro método de pago',
    },
    payment_duplicated_rejection: {
      mobile_heading: 'Aplazar el pago de préstamo',
      html_title: 'Aplazar el pago de préstamo — Vivus.es',
      title: 'Lo sentimos, el pago ha fallado',
      description:
        'Parece que ya has intentado realizar un pago. Por favor, espera unos minutos antes de intentarlo de nuevo.',
      button: 'Entendido',
    },
    extension_limits_rejected: {
      mobile_heading: 'Aplazar el pago de préstamo',
      html_title: 'Aplazar el pago de préstamo — Vivus.es',
      title: 'Lo sentimos, el pago por tarjeta ha fallado',
      description: `Puedes intentarlo de nuevo en unos minutos o utilizar otra tarjeta. Si tienes preguntas llámanos al <strong>{{phone}}</strong>`,
      button: 'Intentar de nuevo',
    },
  },

  bank_account_card: {
    bank_account: 'Cuenta bancaria',
    bank_account_info: `Si has cambiado de cuenta o quieres recibir el dinero en otra, por favor, contacta con nosotros llamando al {{phone}} antes de confirmar tu solicitud.`,
    verified: 'Cuenta verificada',
    change_account: '¿Necesitas cambiar tu cuenta?',
    modal: {
      title: '¿Quieres cambiar tu número de cuenta?',
      cta: 'cambiar',
      cancel: 'ahora no',
    },
  },

  loan_confirm: {
    html_title: 'Revisa y confirma tu solicitud - Vivus.es',
    heading: 'Revisa y confirma tu solicitud',
    heading_additional: 'Revisa las condiciones',
    mobile_heading: 'NUEVO PRÉSTAMO',
    payment_schedule: 'Plan de pago',
    requested_amount_main: 'Importe solicitado',
    requested_amount_additional: 'Nuevo importe total del préstamo',
    interest_main: 'Intereses',
    interest_additional: 'Intereses',
    total_to_return: 'Total a devolver',
    term: 'Plazo',
    last_payment_date: 'Fecha del último pago',
    repayment_date: 'Fecha del pago',
    back_affiliates_button: 'MODIFICAR IMPORTE / PLAZO',
    confirm_button: 'Confirmar',
    consents:
      'He leído y acepto los <a href="https://www.vivus.es/condiciones/generales" target="_blank" rel="noopener">Términos y Condiciones</a>, la <a href="https://www.vivus.es/condiciones/politica-de-privacidad" target="_blank" rel="noopener">Política de Privacidad</a> y la ',
    consents_link: 'Información Normalizada Europea.',
    additional_cesco:
      '  Así mismo, declaro estar informado/a de que un micropréstamo es una categoría específica de préstamos, caracterizada por solicitudes de cantidades pequeñas a corto plazo, y que el coste de Vivus es igual o inferior a la media según los datos publicados por <a href="https://www.vivus.es/prestamos-responsables" target="_blank" rel="noopener">CESCO.</a> <b>Lectura y aceptación obligatoria.</b>',
    bundle: {
      feeRow: 'Servicio Vivus Plus',
      startDate: 'Fecha de inicio <sup>*</sup>',
      startDateDesc:
        'El dinero se enviará en 7 días.<br/>Elige <link /> en el siguiente paso para una transferencia inmediata',
      startDateLink: 'Vivus Plus',
    },
  },

  extension_card: {
    html_title:
      'Ten lista tu tarjeta, necesitaremos que introduzcas la numeración - Vivus.es',
    title: 'Importe a pagar',
    check_box_overdue:
      'Activa el pago  automático y nos encargaremos de cobrar los {{amount}} € de tu préstamo en la nueva fecha de vencimiento {{date}}',
    check_box: 'Activa el pago automático de tus préstamos.',
    check_box_more_information: 'Más información',
    pay_button: 'Hacer pago',
    active_card: {
      title: 'Pagar con tarjeta',
      html_title:
        'Ten lista tu tarjeta, necesitaremos que introduzcas la numeración - Vivus.es',
      card_title: 'Tu tarjeta',
    },
    summary_card: {
      title: 'Resumen del pago',
      price: 'Importe',
      debt_pause: 'Pausar deuda',
    },
    modal: {
      title: 'PAGO AUTOMÁTICO',
      description:
        'Para hacer tu experiencia con nosotros aún más cómoda, vamos a presentarte nuestra utilidad de pago automático.<br /> <br /> Al seleccionarlo en esta casilla, tu tarjeta bancaria quedará registrada de forma 100% segura y en ella se cargarán tus préstamos en la fecha de vencimiento y ¡ya está! Puedes actualizar tus preferencias en tu perfil en cualquier momento o consultar la sección de <a href="https://www.vivus.es/faq/que-es-y-como-se-usa-el-pago-automatico" target="_blank" rel="noopener">FAQS</a> para más detalles.',
      subtitle: 'Principales Beneficios:',
      list_1:
        'Garantiza tu pago en la fecha correcta y evitas cargos adicionales',
      list_2: 'Olvídate de acceder y procesar el pago manualmente.',
      list_3: 'Genera mejores condiciones para tu próximos préstamos',
    },
    overdueBrokenLoan: {
      title: 'Pago parcial',
      description:
        'Si no puedes afrontar el pago total, haz un pago parcial para reducir tu deuda.',
      table_title: '¿Cuánto puedes pagar?',
      table_amount: 'Importe',
      table_contract: 'Contrato nº',
      cto: 'hacer pago',
    },
  },

  approved_documents: {
    html_title: 'Documentos aprobados - Vivus.es',
    header: '¡Ya casi estamos!',
    subtitle:
      'En cumplimiento del Real Decreto 304/2014 de 5 de mayo, envíanos tu DNI/NIE en vigor por ambas caras',
    text: 'Una vez revisados tus documentos te enviaremos una notificación.',
    text2: 'Si lo necesitas, puedes llamar al',
    button: 'Entendido',
  },

  pending_documents: {
    html_title: 'Documentos aprobados - Vivus.es',
    header: '¡Necesitamos verificar tu identidad!',
    subtitle:
      'En cumplimiento del Real Decreto 304/2014 de 5 de mayo, envíanos tu DNI/NIE en vigor por ambas caras',
    text: 'Si ya lo has enviado, recibirás una notificación.',
    text2: 'Si no lo has hecho, continúa ',
    text2Link: 'aquí.',
  },
  active_loan_debt_restructuring: {
    clockDesc: {
      payment:
        'Dispones hasta el <strong>{{dueDate}}</strong> para realizar el siguiente pago',
      payment_first:
        'Dispones hasta el <strong>{{dueDate}}</strong> para realizar el primer pago',
      sign: 'Dispones hasta el <strong>{{dueDate}}</strong> para firmar el acuerdo',
      signAndPay:
        'Dispones hasta el <strong>{{dueDate}}</strong> para firmar el acuerdo y realizar el primer pago',
    },
    drPaymentTable: {
      row1Debt: 'Deuda',
      row2Fee: 'Primer pago',
      row3ManagementFee: 'Gastos de gestión',
      desc: `El {{paymentNumber}} incluye la primera cuota de {{fee}} y los gastos de gestión {{managementFee}} `,
      cto: 'hacer pago',
    },
    offerSteps: {
      step1: 'Iniciar el proceso',
      step2: 'Esperar 48 horas para recibir el acuerdo',
      step3: 'Revisar y firmar el acuerdo',
      step4: 'Realizar el primer pago',
    },
    calendar_section: {
      title: 'Paga tu deuda en 6 cuotas mensuales',
      title_cons: 'Paga tu deuda en 8 cuotas mensuales',
      desc: 'Oferta disponible hasta el <strong>{{dueDate}}</strong>',
      cto: 'empezar',
    },
    calendar_offer_ready: {
      title: 'Tu plan de pagos',
      desc_no_action:
        'Mañana podrás ver aquí, en tu área de cliente, todos los detalles de tu nuevo plan de pagos.',
      cto_full: 'Revisar y firmar',
      cto_pay: 'Pagar',
    },
    calendar_initiated_info_section: {
      title: 'Estamos preparando tu plan de pagos',
      desc: 'Cuando esté listo te enviaremos un email.',
    },
    debt_section: {
      title: 'Deuda pendiente',
      contract: 'Contrato nº {{contract}}',
      amount_desc: 'Importe a pagar <b>hoy</b> para cancelar tu préstamo',
    },
    payment_section: {
      card: 'Pagar con tarjeta bancaria',
      bizum: 'Pagar con Bizum',
    },
    support_section: {
      info: 'Estamos aquí para ayudarte. Si tienes cualquier duda, contacta con nosotros',
      work_hours_weekdays: 'Lunes a Viernes de 8:00 a 18:00 horas',
      work_hours_weekends: 'Sábados de 9:00 a 13:00 horas',
    },
    offer_cons: {
      bulletsCard: {
        title: '¿No puedes pagar tu cuota?',
        bullet1:
          'Queremos ayudarte con el pago de tu deuda <strong>reduciendo los intereses</strong>, aumentando el número de cuotas y <strong>disminuyendo el importe de las mismas.</strong>',
        bullet2:
          'Dividiremos el total de tu préstamo en <strong>8 cuotas</strong> y, una vez tengamos preparado tu nuevo plan de pagos, te enviaremos un mail para que puedas revisarlo y firmarlo.',
        bullet3:
          '<strong>Debes pagar a tiempo</strong> tus nuevas cuotas. Su incumplimiento implicará la reclamación de la totalidad de la deuda.',
        checkbox: 'Estoy conforme y quiero iniciar el proceso.',
      },
      checkbox_help: 'Acepta las condiciones para continuar',
      stepsCard: {
        title: '¿Qué debo hacer?',
      },
      loan_info_card: {
        contract_number: 'Contrato nº {{contract}}',
        title: 'Desglose de tu deuda',
      },
    },
    offer: {
      title: 'Tu plan de pagos',
      desc: 'Para facilitar el pago de tu deuda, te ofrecemos abonarla <strong>en 6 cuotas mensuales.</strong>',
      desc_cons:
        'Para facilitar el pago de tu deuda, te ofrecemos abonarla <strong>en 8 cuotas mensuales.</strong>',
      stepsCard: {
        cto: 'INICIAR EL PROCESO',
      },
      loan_info_card: {
        contract_number: 'Contrato nº {{contract}}',
        title: 'Desglose de tu deuda',
      },
    },
    offerAccepted: {
      calendarCard: {
        title: 'Ya tenemos preparado tu plan de pagos',
        desc: 'Dispones de 5 días para firmar tu acuerdo y  realizar el primer pago. (Antes del 26/05/2024)',
      },
      stepsCard: {
        title: 'Siguientes pasos:',
        leftSide: {
          agreementSigned: 'Acuerdo firmado',
          desc: 'Firma el acuerdo para transformar tu deuda en un plan de pagos de 6 cuotas',
          desc_cons:
            'Firma el acuerdo para transformar tu deuda en un plan de pagos de 8 cuotas',
          cto: 'firmar acuerdo',
        },
      },
    },
    modals: {
      offerRequested: {
        title: 'Plan de pagos solicitado',
        desc: 'En menos de 48 horas, tendrás disponible tu acuerdo para revisarlo y firmarlo.',
        cto: 'ENTENDIDO',
      },
      offerPending: {
        title: 'Tu acuerdo estará listo en:',
        desc: 'En breve tendrás preparado tu plan de pagos personalizado. Te avisaremos por SMS cuando esté listo.',
        cto: 'ENTENDIDO',
      },
      installmentPaid: {
        title: 'Plan de pagos aprobado',
        agreementSigned: 'Acuerdo firmado',
        paymentDone: 'Primer pago realizado',
        cto: 'PROCESO FINALIZADO',
      },
      newAgreement: {
        title: 'Nuevo acuerdo:',
        row1Debt: 'Deuda',
        row2Fee: 'Cuota',
        row3ManagementFee: 'Gastos de gestión',
        checkbox:
          'He leído y estoy conforme con las condiciones de reestructuración de mi préstamo Vivus vigente.',
        cto: 'aceptar y firmar',
      },
    },
    overdue: {
      card_heading: 'Tu plan de pagos',
      card_title: 'Cuota',
      notificationList: {
        row1: 'Tu cuota está impagada.',
        row2: 'Dispones hasta el <strong>{{date}}</strong> para hacer el pago.',
        row3: 'De no hacerlo te reclamaremos el total de la deuda.',
      },
    },
    payment: {
      heading: 'Elige un método de pago',
      title: 'Paga ahora',
      footerAmount: 'Para iniciar la reestructuración de tu deuda.',
      summary: 'Resumen',
      row1: 'Primera cuota',
      row2: 'Gastos de gestión',
      cardPayment: 'Pagar con tarjeta bancaria',
      bizumPayment: 'Pagar con Bizum',
    },
    paymentSchedule: {
      headingV1: 'Desglose de tu deuda',
      headingV2: 'Tu plan de pagos',
      term: 'Plazo',
      total: 'Total pendiente',
      subtitle: 'Siguientes pasos',
      cardPayment: 'Pagar con tarjeta bancaria',
      bizumPayment: 'Pagar con Bizum',
      footerDesc:
        'Si adelantas una cuota, se descontará del mes en curso y, si pagas más, se descontarán del final del préstamo, acortando su duración. Es una amortización en plazo, así que el importe de la cuota no cambiará y deberás pagar las cuotas restantes mensualmente hasta finalizar el préstamo. Aunque procesaremos los pagos de inmediato y te enviaremos confirmación por SMS, tu plan de pagos no quedará actualizado hasta el día siguiente.',
      phase4: {
        desc: 'Dispones hasta el <strong>{dueDate}</strong> para realizar el siguiente pago',
        agreementSigned: 'Acuerdo firmado',
        payments: {
          1: 'Primer pago',
          2: 'Segundo pago',
          3: 'Tercer pago',
          4: 'Cuarto pago',
          5: 'Quinto pago',
          6: 'Sexto pago',
          7: 'Séptimo pago',
          8: 'Octavo pago',
          suffix: ' realizado',
        },
        paymentsPending: {
          1: 'Realiza el primer pago',
          2: 'Realiza el segundo pago',
          3: 'Realiza el tercer pago',
          4: 'Realiza el cuarto pago',
          5: 'Realiza el quinto pago',
          6: 'Realiza el sexto pago',
          7: 'Realiza el séptimo pago',
          8: 'Realiza el octavo pago',
        },
      },
    },
  },

  active_loan: {
    html_title: 'Mi área personal - Vivus.es',
    vivusplus_badge: 'Vivus Plus activo',
    heading: 'Hola {{name}}',
    amount: 'Mi préstamo activo',
    amount_7CONS: 'Mi próxima cuota',
    modal_button: 'ENTENDIDO',
    monthly_payment: 'Pago mensual',
    monthly_payment_7CONS: 'Fecha de pago',
    repayment_date: 'Fecha de devolución',
    contract_number: 'Contrato nº {{contract}}',
    amount_info: 'Total a devolver hoy',
    days_left_one: 'Falta {{count}} día',
    days_left_other: 'Faltan {{count}} días',
    loan_overview: 'Desglose de tu deuda',
    loan_overview_bundle: ' y Vivus Plus',
    loan_overview_7_cons: 'Información de tu préstamo',
    breakdown_debt: 'Desglose de tu deuda',
    schedule_amount_info: 'Fecha de pago {{date}}',
    payment_number: 'Pago {{number}}',
    make_repayment: 'HACER PAGO',
    days_overdue_one:
      '{{count}} Día de retraso <br />Fecha de devolución {{date}}',
    days_overdue_other:
      '{{count}} Días de retraso <br />Fecha de devolución {{date}}',
    loan_info: 'Información sobre el préstamo',
    invoice: 'Descargar la factura',
    additional_amount_unavailable: 'INDISPONIBLE',
    additional_amount_bundle: 'Número de importes adicionales ilimitados',
    additional_amount_no_bundle: 'Importe adicional: 1 solicitud disponible',
    extension_bundle: 'Aplazamiento de 3 días gratis',
    additional_amount_title: '¿Necesitas más dinero?',
    additional_amount_text:
      'Tienes <strong>{{amount}} €</strong> disponibles de tu límite de crédito.',
    additional_amount_text_disabled:
      'Lamentamos comunicarte que en estos momentos esta opción no es posible. Te avisaremos por correo electrónico en cuanto esté disponible de nuevo.',
    extension_title: '¿Necesitas más tiempo?',
    extension_text:
      'Tienes la opción de aplazar la fecha de vencimiento del pago por un coste adicional.',
    overdue_title: 'No hemos recibido el pago',
    overdue_text:
      'Contacta con nosotros lo antes posible para evitar que el importe de tu deuda continúe incrementándose.',
    total_to_repay: 'Total a pagar',
    loan_summary: {
      requested_amount: 'Importe concedido',
      principal_amount: 'Principal pendiente',
      interest_amount: 'Intereses',
      bundle: 'Servicio Vivus Plus',
      penalty_amount: 'Penalizaciones',
      commission_amount: 'Comisión',
      total_invoiced_amount: 'Importe total pendiente',
      bundle_fee: 'Servicio Vivus Plus',
      term: 'Duración del préstamo',
      payment_schedule: 'Plan de pagos',
      has_extension:
        'Has contratado un aplazamiento. Revisa la nueva fecha de pago.',
      repayment_date: 'Fecha del pago',
      last_repayment_date: 'Fecha de vencimiento',
      already_paid: 'Importe pagado',
    },
    broken_loan_summary: {
      requested_amount: 'Importe concedido',
      principal_amount: 'Principal pendiente',
      interest_amount: 'Intereses',
      penalty_amount: 'Penalizaciones',
      commission_amount: 'Comisiones',
      total_invoiced_amount: 'Importe total pendiente',
      term: 'Duración del préstamo',
      payment_schedule: 'Plan de pago',
      has_extension:
        'Has contratado un aplazamiento. Revisa la nueva fecha de pago.',
      repayment_date: 'Fecha del pago',
      last_repayment_date: 'Fecha de vencimiento',
      already_paid: 'Importe pagado',
    },
    overdue_custom_solution: {
      title: '¿Necesitas una solución personalizada?',
      info: 'Más información',
    },
    overdue_section: {
      overdue_error_notif:
        'Si no solucionas tu impago, tus datos podrían incluirse en ficheros de morosidad.',
      overdue_error_broken_notif:
        'Si no solucionas tu impago, tu deuda podrá ser cedida a otro acreedor.',
      penaltyDebtCard: {
        penaltiesSection: {
          title: 'Penalizaciones y Comisiones',
          descriptionWarning:
            'Van a ser añadidos a tu préstamo.<br /> <b>¡Aún estás a tiempo de evitarlo <br /> pagando o aplazando tu deuda!</b>',
          descriptionWarning7CONS:
            'Van a ser añadidos a la mensualidad impagada.<br />',
          descriptionWarning7CONS_part_2:
            '<b>¡Aún estás a tiempo de evitarlo pagando tu cuota!</b>',
          description:
            'Han sido añadidos a tu deuda que seguirá incrementándose diariamente con otras penalizaciones hasta que se resuelva.',
          description_cons_7:
            'Han sido añadidos a tu cuota, que seguirá incrementándose diariamente con otras penalizaciones hasta que se haga el pago.',
        },
        debtSection: {
          contract: 'Contrato nº {{contract}}',
          description: 'Importe a pagar <b>hoy</b> para cancelar tu préstamo',
          submitBtn: 'PAGAR DEUDA',
          title: 'Tu deuda',
        },
        debtSection7Cons: {
          contract: 'Contrato nº {{contract}}',
          description: 'Importe a pagar <b>hoy</b> para regularizar tu deuda',
          submitBtn: 'PAGAR CUOTA',
          title: 'Cuota impagada',
        },
      },
      time: {
        title: 'Para que te reclamemos el total de tu deuda.',
        description: 'Última oportunidad de aplazar el pago de tu deuda.',
        description_7:
          'Última oportunidad para evitar la reclamación del total de tu deuda si pagas la cuota impagada.',
        description_mini8:
          'Última oportunidad de aplazar el pago de tu deuda y eliminar penalizaciones.',
      },
      extensionCard: {
        description:
          'Puedes aplazar la fecha de vencimiento de tu pago por un coste adicional.',
        description_mini8:
          'Puedes aplazar la fecha de vencimiento de tu pago por un coste adicional.',
        submitBtn: 'Aplazar deuda',
        title: '¿Necesitas más tiempo?',
      },
    },
    overdue_broken_desc:
      'Importe a pagar <strong>hoy</strong> para cancelar tu préstamo',
    submitBtn: 'PAGAR DEUDA',
    custom_solution: {
      title: '¿Necesitas una solución  personalizada?',
      desc: 'Más información',
      desc_link: 'aquí',
    },
    overdueBrokenModal: {
      title: 'Llámanos y buscaremos la solución que más se adapte a ti',
      email: 'recibos@vivus.es',
      work_hours_weekdays: 'Lunes a Viernes de 8:00 a 18:00 horas',
      work_hours_weekends: 'Sábados de 9:00 a 13:00 horas',
    },
    bundle_section: {
      title: ' Ventajas de Vivus Plus',
      learn_vivus: {
        title: 'Aprende con Vivus',
        desc: 'Te enseñamos los mejores consejos para ahorrar y controlar tus finanzas',
        link: 'Descúbrelo ahora',
      },
      support: {
        title: 'Soporte VIP',
        desc: 'Atención telefónica exclusiva y sin esperas.',
        link: '<a href="tel:{{phoneLink}}">{{phone}}</a>',
      },
    },
  },

  discount: {
    heading: '¡Tu descuento te está esperando!',
    text_carry_over:
      'Tienes un descuento del {{discount}} aplicado en tu préstamo actual.',
    text_repeated_loan:
      'Pide ahora tu préstamo y disfruta de un {{discount}} de dto.',
    text_additional_amount:
      'Pide ahora tu importe adicional y disfruta de un {{discount}} de dto.',
    validity_extension: 'Descuento válido en aplazamientos de {{terms}} días.',
    validity_additional_amount:
      'Descuento válido hasta el {{date}} para importes de entre {{min}} a {{max}}.',
    validity_repeated_loan:
      'Descuento válido hasta el {{date}} para importes de entre {{min}} a {{max}}.',
    validity_carry_over:
      'Si necesitas más dinero ¡solicítalo ahora y sigue aprovechando tu descuento!',
    interest_before_discount: 'Sin descuento',
    discount_applied: 'Descuento aplicado',
    extension_header: '¡Aprovecha este descuentazo!',
    banner_discount_text: '{{discount}} descuento',
  },

  not_found: {
    html_title: '404 Pagina no encontrada – Vivus.es',
    title: '404',
    subtitle: 'Estás muy cerca de empezar a sentirte Vivus.',
    description: 'Pincha en alguno de estos enlaces:',
    how_it_works: 'Cómo funciona',
    offer: 'Ofertas',
    blog: 'Blog',
    faq: 'Ayuda',
    contacts: 'Contacto',
    about_us: 'Sobre nosotros',
  },

  extension_schedule: {
    new_date: 'Nuevo',
  },

  faq: {
    html_title: 'Ayuda – Vivus.es',
  },

  password_change_success: {
    html_title: 'Contraseña guardada – Vivus.es',
    heading: 'Contraseña guardada',
    continue: 'Entendido',
  },

  change_temporary_password: {
    html_title: 'Modificar mi contraseña – Vivus.es',
    heading: 'Modificar mi contraseña',
    new_password_placeholder: 'Nueva contraseña',
    text: 'La contraseña debe contener al menos 8 carácteres, letras y números o carácteres especiales.',
    submit: 'Guardar contraseña',
  },

  news_consents: {
    html_title:
      'No te pierdas nuestros descuentos y promociones especiales. – Vivus.es',
    heading: 'No te pierdas nuestros descuentos y promociones especiales.',
    description: 'Acepta recibir comunicaciones comerciales.',
    btn: 'Si, acepto',
    decline_btn: 'Lo haré la próxima vez',
  },

  password_recovery: {
    html_title: 'Recuperación contraseña - Vivus.es',
    heading: 'Introduce tu email',
    description: {
      point1:
        'Recibirás un email con los pasos a seguir para generar una nueva contraseña',
      point2:
        'Si no te deja seguir, es posible que tengamos otro email registrado.',
      point2_link: '¿Quieres cambiarlo?',
    },
    email: 'Email',
    continue: 'enviar a mi email',
    cancel: 'Cancelar',
  },

  password_change: {
    html_title: 'Cambio de contraseña - Vivus.es',
    heading: 'Introduce tu nueva contraseña',
    email: 'Email',
    password: 'Nueva contraseña',
    repeat_password: 'Repetir nueva contraseña',
    description:
      'La contraseña debe contener al menos ocho carácteres siendo al menos uno de ellos un número',
    continue: 'guardar contraseña',
    cancel: 'Cancelar',
  },

  password_recovery_success: {
    html_title: 'La contraseña ha sido recuperada con éxito - Vivus.es',
    heading: '¡Enviado! <br /> Comprueba tu email',
    description:
      'Si el correo electrónico introducido coincide con una cuenta registrada, recibirás un email a {{email}} con las instrucciones para establecer una nueva contraseña',
    continue: 'ENTENDIDO',
  },
  voluntaryBanner: {
    title: '¡Gracias por confiar en nosostros!',
    description:
      'Para poder gestionar futuras solicitudes es necesario que adjuntes tu DNI/NIE en vigor en tu área de cliente.',
    uploadBtn: '¡Adjuntar ahora!',
  },
  best_offer: {
    title: 'Oferta personalizada',
    description:
      'Gracias a los datos que nos has facilitado, hemos podido generar una oferta que se ajusta a tus necesidades ',
    card: {
      request: 'Solicitaste',
      offer: 'Podemos ofrecer',
      table: {
        row1: 'Plazo',
        row2: 'Importe solicitado',
        row3: 'Intereses',
        row4: 'Total a devolver',
        row5: 'Fecha de devolución',
      },
    },
    consents_link: 'Información Normalizada Europea del Crédito',
    submitBtn: 'Confirmar',
    footer: {
      title: '¿Cómo se ha calculado el importe de mi préstamo?',
      description: `En línea con nuestra política de financiación responsable, hemos analizado tus datos detenidamente para calcular el importe idóneo para tu primer préstamo Vivus. El importe máximo disponible para tus siguientes préstamos podrá aumentar siempre y cuando, entre otras variables, se mantenga un buen comportamiento de pago. Si tienes alguna consulta no dudes en contactar con nosotros <a href="tel:{phoneLink}">{{phone}}</a> o mail <a href="mailto:info@vivus.es">info@vivus.es</a>`,
    },
  },
  signDrAgreement: {
    html_title: 'Firmar acuerdo - Vivus.es',
    title: 'Firma tu acuerdo',
    description:
      'Es imprescindible para formalizar la reestructuración de tu préstamo.',
    continue_btn: 'CONTINUAR',
    modal: {
      title: 'Revisa y acepta los términos del acuerdo',
      tooltip: {
        readAgreed:
          'Debes leer el acuerdo y aceptar tu conformidad con el mismo antes de  firmar',
        agreed: 'Debes aceptar tu conformidad con el acuerdo antes de firmar',
        read: 'Debes leer el acuerdo antes de firmar',
      },
      checkConditions:
        'He leído y estoy conforme con las condiciones de reestructuración de mi préstamo Vivus vigente.',
      submitBtn: 'FIRMAR',
    },
    footer_link: 'Firmar después',
  },
  signDrAgreementSuccess: {
    title: 'Enhorabuena',
    description:
      'El acuerdo de reestructuración de tu préstamo ha sido firmado con éxito.',
    agree_btn: 'ENTENDIDO',
  },
  cardMissingModal: {
    footer: 'Hoy no, gracias.',
    subCard: '¡Solo tarda un minuto!',
    submitBtn: 'REGISTRAR MI TARJETA',
    title:
      '¡Registra tu tarjeta bancaria y activa el pago automático para decir adios a los intereses de demora!',
  },
  saveCard: {
    html_title: 'GUARDAR TARJETA',
    title: 'Registra tu tarjeta bancaria',
    description:
      'Para finalizar, registra tu tarjeta bancaria y activa el pago automático. Nosotros nos encargaremos de cobrar tu préstamo en la fecha correcta.',
    submit_btn: 'CONTINUAR',
    footer_card:
      '¡Di adios a los intereses de demora y disfruta de ventajas increíbles!',
    footer_link: 'No quiero registrar mi tarjeta ahora',
  },
  autorepay: {
    html_title: 'PAGO AUTOMÁTICO',
    title: 'Activa el pago automático',
    description:
      'Para finalizar, activa el pago automático. Nosotros nos encargaremos de cobrar tu préstamo en la fecha correcta. ',
    submit_btn: 'CONTINUAR',
    footer_card:
      '¡Di adios a los intereses de demora y disfruta de ventajas increíbles!',
    footer_link: 'No quiero activarlo ahora',
  },
  two_fa_phone_modified: {
    html_title: 'Teléfono modificado - Vivus.es',
    title: 'Verifica tu teléfono',
    description: 'Tu número de teléfono ha sido modificado correctamente.',
    button: 'ENTENDIDO',
  },
  unsubscribe_page: {
    html_title: 'Cancelar suscripción - Vivus.es',
    title: 'Cancelar suscripción',
    inputPlaceholderText: 'Indica tu E-mail',
    buttonText: 'Darse de baja',
    canBeIngored:
      'Si has accedido por error puedes ignorar este mensaje y cerrar esta ventana.',
    ifEverythingPutCorrectly:
      'Si has indicado tu E-mail correctamente, será dado de baja de nuestras comunicaciones.',
    weAreSorry:
      'Lamentamos que te vayas 😔. Es posible que te pierdas nuestras próximas ofertas exclusivas… ¡pero no te preocupes! Puedes volver a activarlas en cualquier momento iniciando sesión en tu perfil y actualizando tus preferencias de comunicación.',
    redirectToLogin: 'Iniciar sesión en tu cuenta',
  },
  two_fa_phone_error: {
    html_title: 'Error modificando teléfono - Vivus.es',
    title: 'Verifica tu teléfono',
    description:
      'Se ha producido un error y no ha sido posible modificar tu teléfono. Inténtalo de nuevo.',
    button: 'REINTENTAR',
    button_footer:
      'Si no puedes continuar con el proceso escríbenos un email a <a target="_blank" href="mailto:info@vivus.es">info@vivus.es</a> indicándonos el nuevo número de teléfono móvil que quieres registrar y adjuntando fotografía de tu DNI/NIE por ambas caras.',
  },
  breakdown_debt: {
    html_title: 'Desglose de tu deuda',
    title: 'Desglose de tu deuda',
    title_card: 'Cuota impagada',
    summary: {
      fee: 'Cuota',
      penalties: 'Penalizaciones',
      commission: 'Comisión',
    },
    card_payment: 'Pagar con tarjeta bancaria',
    bizum_payment: 'Pagar con bizum',
  },

  installment_payment: {
    html_title: 'Pago de instalación',
    title: 'Elige un método de pago',
    title_card: 'Paga ahora',
    footer_card: 'para regularizar tu deuda',
    summary: {
      fee: 'Cuota',
      penalties: 'Penalizaciones',
      commission: 'Comisión',
    },
    payment_schedule: {
      term: 'Plazo',
      pay: 'Importe total pendiente',
    },
    card_payment: 'Pagar con tarjeta bancaria',
    bizum_payment: 'Pagar con bizum',
  },
  dana: {
    html_title: 'DANA',
    title: 'Apoyo a los afectados por la DANA en España',
    description:
      'Sabemos que te encuentras en una de las zonas afectadas por la DANA. Entendemos que la situación es complicada y estamos aquí para apoyarte. Llámanos al 91 084 05 59 y buscaremos contigo una solución.',
    button: 'continuar',
  },
  bundle: {
    faq_questions_title: 'Preguntas y respuestas',
    banner: {
      desc: 'No olvides elegir <h3>Vivus Plus</h3> para disfrutar de sus ventajas',
      link: 'aquí',
    },
    bundleDataCard: {
      tab_with: 'Con Vivus Plus',
      tab_without: 'Sin Vivus Plus',
      recommended: 'RECOMENDADO',
      with_title: 'Con Vivus Plus',
      without_title: 'Sin Vivus Plus',
      feature_free_extension: {
        title: 'Aplazamiento gratuito',
        with_value: 'De tres días',
        without_value: 'No incluido',
      },
      features: [
        {
          title: 'Recibe el dinero al instante',
          with_value: 'Al instante',
          without_value: 'Se envía en 7 días',
        },
        /* temporal revert: Bundle insurance
         * {
         *   title: 'Seguro',
         *   badge: '¡Nuevo!',
         *   with_value: 'Protección durante tu préstamo',
         *   sub_items: [
         *     'Fallecimiento por accidente',
         *     'Incapacidad permanente absoluta<br /><p>(tanto por accidente como por enfermedad)</p>',
         *   ],
         *   without_value: 'No incluido',
         * },
         */
        {
          title: 'Importes adicionales ilimitados',
          with_value: 'Ilimitados',
          without_value: '1 solo importe adicional',
        },
        {
          title: 'Contenido exclusivo',
          with_value: 'Mejora tus finanzas con Vivus',
          without_value: 'No incluido',
        },
        {
          title: 'Soporte telefónico prioritario',
          with_value: 'Prioritario',
          without_value: 'Soporte estándar',
        },
      ],
      checkbox_label:
        'Declaro conocer y aceptar las condiciones de Vivus Plus. Asimismo, he sido informado/a de que el precio del servicio es de {{amount}} euros y me comprometo a abonarlo en la fecha de vencimiento de mi préstamo. En caso de tener una tarjeta bancaria registrada en mi área de cliente, autorizo a Vivus a cargar en la misma de forma automática el importe mencionado anteriormente llegada la fecha de vencimiento de mi préstamo.',
      with_button: 'CONSEGUIR MI DINERO YA',
      without_warning_title: 'Transferencia estándar',
      without_warning_desc:
        'Estoy de acuerdo en recibir mi dinero dentro de 7 días sin las ventajas de Vivus Plus.',
      without_button: 'CONTINUAR SIN VIVUS PLUS',
    },
    popup: {
      title_repeated_loan: '¿Sabes qué es Vivus Plus?',
      /* temporal revert: Bundle insurance
      * desc_repeated_loan:
          'Con Vivus Plus te enviaremos el dinero de forma inmediata{{freeExtensions}}, múltiples importes adicionales, soporte VIP, y Seguro para tu préstamo',
      */
      desc_free_extensions:
        ' y disfrutarás de beneficios como aplazamientos gratuitos',
      desc_repeated_loan:
        'Con Vivus Plus te enviaremos el dinero de forma inmediata{{freeExtensions}}, múltiples importes adicionales y soporte VIP',
      title_confirm: '¿Quieres tu dinero al instante?',
      /* temporal revert: Bundle insurance
      * desc_confirm:
        'Sin Vivus plus, recibirás el dinero dentro de 7 días. Sin embargo, si contratas Vivus Plus te enviaremos el dinero de forma inmediata{{freeExtensions}}, múltiples importes adicionales, soporte VIP, y Seguro para tu préstamo',
      */
      desc_confirm:
        'Sin Vivus plus, recibirás el dinero dentro de 7 días. Sin embargo, si contratas Vivus Plus te enviaremos el dinero de forma inmediata{{freeExtensions}}, múltiples importes adicionales y soporte VIP',
    },
    repeated_loan_table: {
      initial_date: 'Fecha de inicio <sup>*</sup>',
      payment_date: 'Fecha de pago previsto',
      footer:
        '<sup>*</sup></sup> El dinero se enviará en 7 días. Contrata Vivus Plus en el paso final para que la transferencia sea inmediata.',
    },
    bundle_steps: {
      step1_title: 'Aprobado',
      step1_text_offer: 'Hoy<br /><strong>{{today}}</strong>',
      step1_text_pending: 'El dia<br /><strong>{{startDate}}</strong>',
      step1_2: '+ {{days}} días',
      step2_title: 'Transferencia',
      step2_text: 'Programada el<br /><strong>{{date}}</strong>',
      step2_3: '{{term}} días',
      step3_title: 'Pago',
      step3_text: 'Fecha de pago<br /><strong>{{date}}</strong>',
    },
    bundle_waiting: {
      title:
        'Te enviaremos tu dinero en <strong>{{days}} días</strong><br />(fecha estimada: <strong class="date">{{date}}</strong>)',
      desc: 'El dinero será transferido a esta cuenta:',
      footer:
        'Recibirás el contrato de tu crédito cuando te enviemos el dinero.',
    },
    bundle_offer: {
      html_title: 'vivusplus offer',
      title: '¡Tu préstamo ha sido aprobado!',
      subtitle: 'Te enviaremos tu dinero en <strong>7 días.</strong>',
      card: {
        title: 'Consigue tu dinero ya',
        subtitle:
          'Con Vivus Plus recibirás tu préstamo al instante y muchas ventajas más',
      },
      faq_questions: [
        {
          question: '¿Por qué necesito el servicio Vivus Plus?',
          answer:
            'Con Vivus Plus disfrutarás de las siguientes ventajas:<br /><br /><strong>Dinero al instante:</strong> tu préstamo rápido se enviará de inmediato, sin esperas. Sin Vivus Plus, la transferencia de dinero y los importes adicionales que solicites tardarán 7 días.<br /><br /><strong>Importes adicionales ilimitados:</strong> solicita importes adicionales tantas veces como necesites hasta llegar a tu límite de crédito.<br /><br /><strong>Aprende con Vivus:</strong> accede a contenido exclusivo con artículos que te enseñarán a optimizar tus finanzas, ahorrar y mejorar tu economía.<br /><br /><strong>Soporte VIP:</strong> recibe atención prioritaria y exclusiva sin tiempos de espera.',
          answer_with_free_extensions:
            'Con Vivus Plus disfrutarás de las siguientes ventajas:<br /><br /><strong>Dinero al instante:</strong> tu préstamo rápido se enviará de inmediato, sin esperas. Sin Vivus Plus, la transferencia de dinero y los importes adicionales que solicites tardarán 7 días.<br /><br /><strong>Aplazamiento gratuito:</strong> puedes atrasar el pago de tu préstamo 3 días sin coste adicional.<br /><br /><strong>Importes adicionales ilimitados:</strong> solicita importes adicionales tantas veces como necesites hasta llegar a tu límite de crédito.<br /><br /><strong>Aprende con Vivus:</strong> accede a contenido exclusivo con artículos que te enseñarán a optimizar tus finanzas, ahorrar y mejorar tu economía.<br /><br /><strong>Soporte VIP:</strong> recibe atención prioritaria y exclusiva sin tiempos de espera.',
        },
        {
          question: '¿Qué pasa si no elijo el servicio Vivus Plus?',
          answer:
            'Sin Vivus Plus, no tendrás tu <strong>dinero</strong> al momento. Tendrás que esperar 7 días hasta recibir tu préstamo e importes adicionales. Además solo tendrás un <strong>importe adicional</strong> de crédito disponible.<br /><br />Por otra parte, Vivus Plus incluye la sección <strong>Aprende con Vivus</strong> con <strong> contenido exclusivo para optimizar tu economía y saber cómo ahorrar y, además, cuenta con soporte VIP</strong> para hablar con uno de nuestros especialistas sin esperas. Si no eliges Vivus Plus, no tendrás disponibles estas opciones.',
          answer_with_free_extensions:
            'Sin Vivus Plus, no tendrás tu <strong>dinero</strong> al momento. Tendrás que esperar 7 días hasta recibir tu préstamo e importes adicionales. Además, no dispondrás del <strong>aplazamiento gratuito</strong> de tres días y solo tendrás un <strong>importe adicional</strong> de crédito disponible.<br /><br />Por otra parte, Vivus Plus incluye la sección <strong>Aprende con Vivus</strong> con <strong> contenido exclusivo para optimizar tu economía y saber cómo ahorrar y, además, cuenta con soporte VIP</strong> para hablar con uno de nuestros especialistas sin esperas. Si no eliges Vivus Plus, no tendrás disponibles estas opciones.',
        },
        {
          question: '¿Puedo añadir el servicio Vivus Plus más tarde?',
          answer:
            '<strong>Sí,</strong> puedes contratar Vivus Plus dentro de los 7 días que tardarás en recibir el dinero si eliges la transferencia estándar. Durante este período, puedes cambiar de opinión y activar el servicio Vivus Plus desde tu área de cliente.  Una vez enviado el dinero, perderás la oportunidad de contratar Vivus Plus y acceder a sus ventajas.',
        },
        {
          question: '¿Cuánto cuesta Vivus Plus?',
          answer:
            'Puedes consultar el precio del servicio Vivus Plus en tu área de cliente o al inicio de este apartado llamado <strong>Consigue tu dinero ya.</strong>',
        },
        {
          question:
            '¿Elegir Vivus Plus puede afectar las condiciones de mi préstamo rápido?',
          answer:
            'Vivus Plus no modifica los términos de tu préstamo rápido, aunque sí afecta a la fecha de inicio y pago del préstamo. Al <strong>contratar Vivus Plus</strong> recibes el dinero solicitado al momento y sin Vivus Plus tendrás que esperar 7 días para recibirlo. Recuerda que Vivus Plus es un servicio independiente de tu crédito, aunque ambos se abonarán juntos en la fecha de vencimiento del préstamo.',
        },
        {
          question: '¿Vivus Plus es una compra única?',
          answer:
            '<strong>Sí,</strong> es una compra única que se paga con la devolución de tu préstamo.',
        },
        {
          question: '¿Puedo cancelar el servicio Vivus Plus?',
          answer: '<strong>No,</strong> no se puede cancelar.',
        },
        {
          question: '¿Puedo cancelar mi préstamo de forma anticipada?',
          answer:
            'Sí, <strong>con Vivus Plus puedes cancelar tu préstamo rápido.</strong> Para saber más sobre las condiciones de devolución de tu préstamo debes dirigirte a tu área de cliente y allí encontrarás toda la información.',
        },
        {
          question: '¿Qué es un importe adicional?',
          answer:
            'Un importe adicional es la opción de solicitar más dinero hasta tu límite de crédito tras haber contratado tu préstamo Vivus.<br /><br /><strong>Con Vivus Plus</strong>: tienes la libertad de solicitar importes adicionales hasta tu límite de crédito siempre que los necesites y recibirlos de manera inmediata. Puedes consultar los importes disponibles en tu área de cliente.<br /><br /><strong>Sin Vivus Plus</strong>: puedes solicitar un importe adicional solo una vez. Puedes hacerlo desde la fecha de recepción de tu crédito y hasta 7 días antes de la fecha de pago del mismo. El dinero del importe adicional se enviará en un plazo de 7 días, al igual que la cantidad del préstamo principal.',
        },
      ],
    },
    bundle_pending: {
      time_section_desc:
        'Aún estás a tiempo de contratar Vivus Plus.<br />Puedes hacerlo antes de<br />',
    },
    bundle_confirmed: {
      html_title: 'bundle confirmed',
      title: '¡Vivus Plus activado!<br />Tu dinero está en camino.',
      title_additional:
        '<strong>¡Enhorabuena!</strong><br />Se ha aprobado la ampliación del importe<br />de tu préstamo',
      desc: 'Tu dinero estará en tu cuenta en menos de 15 minutos.<sup>*</sup>',
      card: {
        title: '¿Qué sigue?',
        money:
          '<strong>Recibe tu dinero</strong><br />En breve lo tendrás en tu cuenta',
        communication:
          '<strong>Revisa tus emails y SMS</strong><br />Encontrarás la documentación relativa a los servicios contratados',
        benefits:
          '<strong>Disfruta de más ventajas</strong><br />Accede a tu área de cliente y descubre otros beneficios',
        payment:
          '<strong>Pago</strong><br />En la fecha de vencimiento de tu préstamo',
        cto: 'ir al área de cliente',
      },
      footer: {
        title: 'El dinero será transferido a esta cuenta:',
        desc: '<sup>*</sup> En ocasiones, por motivos de operativa bancaria ajenos a Vivus, la transferencia puede tardar hasta 48 horas.',
      },
    },
    bundle_no_confirmed: {
      html_title: 'vivus no confirmed',
      title: 'La ampliación del importe de tu préstamo ha sido aprobado',
      cto: 'ir al área de cliente',
      faq_questions: [
        {
          question: '¿Por qué tengo que esperar 7 días para recibir mi dinero?',
          answer:
            '7 días es el tiempo de espera correspondiente a una transferencia estándar de nuestros créditos. Sin embargo, si deseas recibir tu dinero de forma más rápida,  puedes contratar el servicio <strong>Vivus Plus</strong> cuando solicites tu próximo préstamo.',
        },
        {
          question: '¿Puedo recibir el dinero al instante?',
          answer:
            'Sí, tienes la opción de recibir tu dinero de forma inmediata si contratas el servicio <strong>Vivus Plus</strong> en tu próximo préstamo.',
        },
      ],
    },
    bundle_vivus_plus: {
      html_title: 'vivus',
      title: 'Vivus Plus',
      badge: 'Vivus Plus activo',
      card_title: 'Principales ventajas',
      card_benefits: [
        {
          badge: 'Instantáneo',
          text: 'Dinero al instante',
        },
        {
          badge: '1 aplazamiento',
          text: '3 días gratis',
        },
        {
          badge: 'Ilimitados',
          text: 'Importes adicionales',
        },
        {
          badge: 'Incluido',
          text: 'Contenido exclusivo',
        },
        {
          badge: 'Incluido',
          text: 'Soporte VIP',
        },
        {
          badge: 'Incluido',
          text: 'Seguro',
        },
      ],
      faq_questions: [
        {
          question: '¿Cómo solicito más dinero?',
          answer:
            '<strong>Accede a tu área de cliente</strong> y comprueba tu límite de crédito disponible. Allí encontrarás los pasos detallados para solicitar más dinero de forma rápida y sencilla.',
        },
        {
          question: '¿Vivus Plus implica algún coste adicional?',
          answer:
            'No, en este momento ya <strong>estás disfrutando del servicio Vivus Plus y de sus ventajas</strong>, por lo que no tiene coste adicional.',
        },
        {
          question: '¿Cuándo expira el servicio Vivus Plus?',
          answer:
            'Puedes disfrutar de los <strong>beneficios y ventajas del servicio Vivus Plus</strong> hasta que acabe tu préstamo.',
        },
        {
          question:
            '¿A qué teléfono puedo llamar para hablar sobre Vivus Plus?',
          answer: `El teléfono de ayuda para los clientes que tienen activo el servicio Vivus Plus es: <strong>${PHONE_BUNDLE}</strong>`,
        },
        {
          question: '¿Puedo cancelar Vivus Plus a mitad del préstamo?',
          answer: '<strong>No</strong>, no se puede cancelar.',
        },
        {
          question:
            'Si pago por adelantado, ¿recibiré un reembolso parcial de Vivus Plus?',
          answer:
            '<strong>No</strong>, el pago anticipado incluye el importe principal del préstamo, los intereses generados y el coste total del servicio Vivus Plus, sin opción a reembolso parcial.',
        },
        /* temporal revert: Bundle insurance
         * {
         *   question: '¿Qué cubre mi seguro?',
         *   answer:
         *     '<ul><li>Fallecimiento por accidente</li><li>Incapacidad permanente absoluta (tanto por accidente como por enfermedad)</li></ul>',
         * },
         * */
      ],
    },
    bundle_extension: {
      badge: 'Aplazamiento de 3 días gratis',
    },
    additional_card: {
      title: 'Envío programado',
      desc: 'El importe adicional que has solicitado se enviará a tu cuenta el <strong>{{date}}</strong>.',
    },
  },
  bank_account_unnax_change: {
    cardGreenMsg1: 'El IBAN no es el número de tu tarjeta bancaria',
    cardGreenMsg2:
      'Puedes encontrar tu número de cuenta IBAN en tu banca online y copiarlo desde allí',
    cardGreenMsg3:
      'Si no encuentras tu número de IBAN, contacta con tu banco y pide ayuda',
    cardHelper: 'Ejemplo: ES91 2100 0418 4502 0005 1332',
    cardGreenTitle: 'Tu cuenta bancaria',
    continueBtn: 'confirmar',
    understandBtn: 'entendido',
    error:
      'El número introducido contiene errores. Si necesitas ayuda, contacta con nosotros {{phoneNumber}}.',
    subtitle: 'Tu número de cuenta actual',
    title: 'Cambiar cuenta bancaria',
    modalTitle: '¿Qué es el IBAN?',
    modalText:
      '<p>Las siglas IBAN (International Bank Account Number) significan Código Internacional de Cuenta Bancaria en español.</p>\n<p>El IBAN <strong>llegó en 2014 para sustituir al desaparecido CCC</strong>, que se correspondía con las siglas Código Cuenta Cliente y hace referencia a los veinte dígitos que identificaban a las cuentas corrientes bancarias en nuestro país.</p>\n<p>Con la intención de <strong>homogeneizar las operaciones bancarias entre los países de la zona euro</strong> nació el IBAN que sirve para identificar nuestras cuentas bancarias. La composición del IBAN es alfanumérica  y la forman 24 caracteres. La explicamos:</p>\n<ol>\n<li>Los cuatro primeros caracteres son <strong>dos letras que identifican al país</strong> (en España, ES) y dos números que son un código de control.</li>\n<li>Los cuatro siguientes son <strong>números que identifican a la entidad bancaria.</strong></li>\n<li>Cuatro números más que hacen referencia al <strong>código de la sucursal.</strong></li>\n<li>Por último, <strong>doce números hasta completar los 24</strong> que forman el IBAN.</li>\n</ol>\n<p>Por ejemplo: ES00 1111 2222 333333333333</p>\n<p>En realidad el IBAN es exactamente igual al ya extinto CCC pero anteponiéndole el código alfanumérico ESXX en el caso de España, donde XX son los dígitos de control.</p>\n<p>Puedes encontrar tu número de IBAN en <strong>los detalles de tu cuenta en el servicio de banca online</strong> de tu banco.</p>',
    success: 'Cuenta bancaria modificada correctamente',
    errorResult: 'Lo sentimos, no hemos podido modificar tu número de cuenta',
    tryAgain: 'Intentar de nuevo',
    loading: 'Comprobando tu información',
    loadingDesc:
      'Por favor, no cierres la ventana todavía.<br/>Este proceso puede tardar unos minutos.',
    attempts_one: 'Queda {{count}} intento',
    attempts_other: 'Quedan {{count}} intentos',
  },
  breadcrumb: {
    steps: [
      'Iniciar el proceso',
      'Esperar 48h para recibir el acuerdo por email',
      'Revisar y firmar el acuerdo',
      'Realizar el primer pago',
    ],
  },
  otp_modal: {
    description: 'Para revisarlo:',
    title:
      'Puede que los SMS estén llegando a tu bandeja de mensajes no deseados (SPAM)',
    android_app: 'En Android:',
    ios_app: 'En iOS:',
    android_points: {
      1: 'Abre la app de Mensajes',
      2: 'Pulsa en los tres puntos verticales',
      3: 'Pulsa en Spam y bloqueado',
    },
    ios_points: {
      one: 'Ve a Ajustes del sistema',
      2: 'Selecciona la app Mensajes',
      third: 'Activa la opción Filtrar desconocidos',
    },
    cto: 'entendido',
  },
  rejectedTimer: {
    html_title: 'Rechazado temporal - vivus',
    cto: 'entendido',
    desc: 'Podrás intentarlo de nuevo dentro de:',
    no_timer: 'Te avisaremos cuando sea posible cursar una nueva solicitud',
    title: 'En estos momentos no puedes solicitar un préstamo',
  },
  legalTermsModal: {
    legal_terms: 'Información sobre el préstamo',
    invoice_filename: 'factura',
    error:
      'Error al obtener detalles del préstamo. Inténtalo de nuevo más tarde.',
  },
  insurancePolicy: {
    mobile_heading: 'Todo incluido',
    text: 'Añade el <strong>seguro por solo 3€</strong> y disfruta de tu préstamo sin preocupaciones',
    title: 'Tu préstamo con el pack <br /><strong>"Todo incluido"</strong>',
    badge: 'Sólo {{amountInsurance}}€',
    list: {
      1: {
        title: 'Protección de tu préstamo sin coste adicional',
        desc: 'Seguro de accidentes',
      },
      2: {
        title: 'Decisión exprés',
        desc: 'Respuesta inmediata a tu solicitud',
      },
      3: {
        title: 'Soporte telefónico prioritario',
        desc: 'Sin esperas, siempre que lo necesites',
      },
    },
    footer:
      'El importe no lo pagas ahora, sino en la fecha de pago de tu préstamo',
    cto: 'añadir',
    cancel: 'Continuar sin protección',

    rowSection: {
      text: 'Servicio Todo Incluido',
      tag_added: 'añadido',
      tag_no_added: 'no añadido',
      cto: 'Quitar',
      cto_again_disabled: 'Añadir',
      cto_disabled: 'Añadir',
      list: {
        1: 'Decisión exprés',
        2: 'Seguro de accidentes',
        3: 'Soporte telefónico prioritario',
      },
    },
  },
  skipInsuranceModal: {
    title: '¿Estás seguro?<br />Tu préstamo quedará sin protección',
    pack_label: 'Pack <strong>"Todo incluido"</strong>',
    list: {
      1: 'Seguro de accidentes',
      2: 'Decisión exprés',
      3: 'Soporte telefónico prioritario',
    },
    cta_add: 'Añadir por {{amount}}€',
    cta_continue: 'Continuar sin protección',
  },
  confirmWithoutInsuranceModal: {
    title: 'Tu préstamo con el pack <br /><strong>"Todo incluido"</strong>',
    badge: 'Solo {{amount}}€',
    cta_add: 'Añadir',
    footer:
      'El importe no lo pagas ahora, sino en la fecha de pago de tu préstamo',
    link_continue: 'Continuar sin protección',
  },
  selektra: {
    html_title: 'selectra',
    mobile_title: 'selectra',
    title: '¿Estás pagando de más en tus facturas?',
    desc: 'Miles de personas pagan de más en luz, gas, internet y móvil sin saberlo.<br/><br/>Recibe <strong>el asesoramiento gratuito de Selectra</strong> para reducir tus facturas',
    cta: 'comprobar gratis',
    skip_zero: 'Saltar',
    skip_one: 'Saltar en {{count}}s',
    skip_other: 'Saltar en {{count}}s',
  },
};

export default es;
